// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ThanksModal__imageWrapper--30uqe","image":"ThanksModal__image--tEzse","text":"ThanksModal__text--2wueP"};